import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-screen-2xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            Discover Top{" "}
            <span className="text-accent-500">ACBuy</span>{" "}
            <span className="text-accent-500">Categories</span>
          </h2>
          <p className="mt-3 text-foreground-500 max-w-xl mx-auto text-sm md:text-base">
            Browse all acbuyspreadsheet product categories — each listing is verified and updated regularly
            with fresh supplier data, pricing comparisons, and availability insights.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-accent-300/60 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="aspect-[4/3] w-full overflow-hidden bg-background-100">
                <img
                  src={cat.cardImageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-3 md:p-4 flex flex-col gap-1 flex-1">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}